// extracted by mini-css-extract-plugin
module.exports = {"item":"heroList_item__UKvmo","list":"heroList_list__A3E_l","isVisible":"heroList_isVisible__e0uNg","hide":"heroList_hide__cMtAd"};